import { MdArrowDropDown, MdOutlineKeyboardArrowDown } from 'react-icons/md';

interface Props {
  children: JSX.Element;
  state: 'pending' | 'success' | 'error' | 'warning';
  expand?: boolean;
}

export default function StatusChip({ state, children, expand = false }: Props) {
  return (
    <div
      className={`w-max px-3 py-1 text-sm flex items-center gap-1 rounded-full font-semibold cursor-pointer
    ${state === 'pending' && 'text-[#2D7AFF] bg-[#D5EAFF]'}
    ${state === 'success' && 'text-[#23C45E] bg-[#D3FCD2]'}
    ${state === 'error' && 'text-[#D33921] bg-[#FCE5D2]'}
    ${state === 'warning' && 'text-[#E5A800] bg-[#FDF5CA]'}
     `}
    >
      {children}
      {expand && <MdOutlineKeyboardArrowDown className="text-black" />}
    </div>
  );
}
